var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col pt-5 justify-content-center"},[_c('h2',[_vm._v("Uh Oh! Looks like you went to a page that doesn't exist on dyllew.github.io")]),_c('router-link',{staticClass:"router-link",attrs:{"to":"/"}},[_vm._v("Click this link to go home.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }